import { create } from "zustand";

interface ReportState {
  printHeaders: any[];
  updatePrintHeaders: (headers: any[]) => void;
  printColumns: any[];
  updatePrintColumns: (columns: any[]) => void;
  showFullAssetModal: boolean;
  updateShowFullAssetModal: (show: boolean) => void;
  showAssetTransferModal: boolean;
  updateShowAssetTransferModal: (show: boolean) => void;
  showStockVerificationModal: boolean;
  updateShowStockVerificationModal: (show: boolean) => void;
  showAlarmModal:boolean;
  updateShowAlarmModal: (show: boolean) => void;
  isLoading: boolean;
  updateIsLoading: (isLoading:boolean) => void;
  reset: () => void;
  showPageOptions: boolean;
  updateShowPageOptions: (show: boolean) => void;
}
const initialQuery = {
  filters: [],
  sorts: [],
  page: 0,
  pageSize: 1000,
  search: "",
}

const useReport = create<ReportState>()((set) => ({
    printHeaders: [],
    updatePrintHeaders: (headers) =>
    set((state) => ({ ...state, printHeaders: headers })),
    printColumns: [],
    updatePrintColumns: (columns) =>
    set((state) => ({ ...state, printColumns: [...state.printColumns, ...columns] })),
    showFullAssetModal: false,
    updateShowFullAssetModal: (show) =>
    set((state) => ({ ...state, showFullAssetModal: show })),
    showAssetTransferModal: false,
    updateShowAssetTransferModal: (show) =>
    set((state) => ({ ...state, showAssetTransferModal: show })),
    showStockVerificationModal: false,
    updateShowStockVerificationModal: (show) =>
    set((state) => ({ ...state, showStockVerificationModal: show })),
    showAlarmModal: false,
    updateShowAlarmModal: (show) =>
    set((state) => ({...state, showAlarmModal: show})),
    isLoading: false,
    updateIsLoading: (isLoading) =>
    set((state) => ({...state, isLoading: isLoading})),
    reset: () => set((state) => ({ ...state, printColumns: [] , printHeaders: []})),
    showPageOptions: false,
    updateShowPageOptions: (show) =>
    set((state) => ({...state, showPageOptions: show})),
}));

export default useReport;
